module.exports = __webpack_public_path__ + "static/gumroad-741963dc446f8141187a8a211e048716.png";